type PriceChangeCellProps = {
  priceChange: string | null;
  isPercentValue?: boolean;
};

function customFormatPercentage(value?: number, isPercentValue = false) {
  if (value == null) {
    return '-';
  }

  const percentage = isPercentValue ? value : value * 100;
  const absolutePercentage = Math.abs(percentage);

  if (absolutePercentage > 10_000) {
    return percentage > 0 ? '>+10K%' : '<-10K%';
  }

  if (absolutePercentage > 100) {
    const value = percentage.toLocaleString('en-US', { maximumFractionDigits: 0 });
    return `${percentage > 0 ? '+' : ''}${value}%`;
  }

  const fixedValue = percentage.toFixed(1);

  // If it rounds to 0.0, return without any sign
  if (fixedValue === '0.0' || fixedValue === '-0.0') return '0.0%';

  // Otherwise add + sign for positive values (negative values already have -)
  return `${percentage > 0 ? '+' : ''}${fixedValue}%`;
}

export const PriceChangeCell = ({ priceChange, isPercentValue = false }: PriceChangeCellProps) => {
  const priceChangeParsed = priceChange != null ? parseFloat(priceChange) : undefined;
  const priceChangeFormatted = customFormatPercentage(priceChangeParsed, isPercentValue);

  const textColor =
    priceChangeFormatted === '0.0%' || priceChangeFormatted === '-'
      ? 'text-token-gray-800'
      : priceChangeParsed != null && priceChangeParsed > 0
        ? 'text-token-green-1000'
        : 'text-token-red-900';

  return <span className={textColor}>{priceChangeFormatted}</span>;
};
